import React, { useState } from "react";
import { colors } from "../../../themes/Colors";

const BaseButtons = ({
  label,
  width,
  borderRadius,
  backgroundColor,
  onClick,
  color,
  height,
  disabled,
  noShadow,
  padding,
  fontSize,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <button
      disabled={disabled}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={onClick}
      style={{
        height: height ? height : 40,
        minHeight: height ? height : 40,
        width: width,
        borderRadius: borderRadius,
        backgroundColor: backgroundColor,
        borderWidth: 0,
        //WebkitBoxShadow: noShadow
        //  ? "0px 0px 0px 0px #00000070"
        //  : "-5px 5px 15px -1px #00000070",
        color: color ? color : colors.white,
        fontWeight: "bold",
        transition: "all 0.6s",
        opacity: disabled ? 0.3 : hover ? 1 : 1,
        padding: padding,
        fontSize: fontSize ? fontSize : null,
      }}
    >
      {label}
    </button>
  );
};

export default BaseButtons;
